import { useEffect, useRef } from "react";

interface TicketSelectCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange: (event: unknown) => void;
  label: string;
}

/**
 * Row / header selection for the ticket list. The label fills the cell so the
 * whole cell toggles, and clicks stop here - rows open the ticket on click.
 */
export default function TicketSelectCheckbox({
  checked,
  indeterminate = false,
  onChange,
  label,
}: TicketSelectCheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !checked && indeterminate;
    }
  }, [checked, indeterminate]);

  return (
    <label
      className="-mx-3 -my-4 flex cursor-pointer items-center px-3 py-4"
      onClick={(e) => e.stopPropagation()}
    >
      <input
        ref={ref}
        type="checkbox"
        aria-label={label}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 cursor-pointer rounded border-gray-300 text-orange-600 focus:ring-orange-500"
      />
    </label>
  );
}
